import React, {useState, useRef, useEffect} from 'react';
import { useHistory } from "react-router-dom";
import { set, get, remove } from '../../services/storage.service';
import { saveMindmap, loadMindmap, checkMindmap, removeMindmap } from '../../services/local.mindmap';
import './CreateMindmap.css';
import axios from 'axios';
import {
    IonPage,
    IonContent, 
    IonButton,IonToolbar,IonIcon,
    IonSlides,
    IonCard,
    IonTextarea,
    IonInput,
    IonText,
    IonLabel,
    IonLoading,
    IonAlert,
    IonItem,
    IonSlide,
    IonHeader,
    IonFabButton,
    isPlatform,
} from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import { logOutOutline, chevronBackOutline, arrowForwardOutline, arrowBackOutline  } from 'ionicons/icons';

import FooterCom from '../../components/FooterComponent';
import LoginCheck from "../../components/LoginCheck";

const CreateMindmap: React.FC = () => {
    var error = false;
    const history = useHistory();
    const [swiper, setSwiper] = useState<any>({});
    const [currentcheck, setCurrent] = useState<any>('0');

    const [mapquestion, setMindmap] = useState<string>('');
    const [curiosity, setCuriosityquestion] = useState<string>('');
    const [responsibilityexplore, setResponsibilityExplore] = useState<string>('');
    const [empowermentobstacles, setEmpowermentObstacles] = useState<string>('');
    const [empowermentovercome, setEmpowermentOvercome] = useState<string>('');
    const [observationdata, setObservationData] = useState<string>('');
    const [communicationcollection, setCommunicationCollection] = useState<string>('');
    const [collaboration, setCollaboration] = useState<string>('');
    const [planningorganizingsteps, setPlanningOrganizingSteps] = useState<string>('');
    const [problemsolvingcreativity, setProblemSolvingCreativity] = useState<string>('');

    const [firstname, setFirstName] = useState<string>('');
    //const [lastname, setLastName] = useState<string>('');
    const [mindmaptitle, setMindMapTitle] = useState<string>('My Mind Map');
    const [schoolname, setSchoolName] = useState<string>('');

    const [isSaved, setIsSaved] = useState<any>('none');
    const [issuccess, setIssuccess] = useState<boolean>(false);
    const [winmessage, setWinMessage] = useState<string>("");
    const [winmessagetitle, setWinMessageTitle] = useState<string>("");
    const [showLoading, setShowLoading] = useState(false);

    const plat = isPlatform('mobileweb');
    const desk = isPlatform('desktop');

    let introurl = "public/assets/video/mindmapintro.mp4";
    let curiosityurl = "public/assets/video/mindmapcuriosity.mp4";  
    let responsibilityurl = "public/assets/video/mindmapempowerment.mp4";
    let empowermenturl = "public/assets/video/mindmapempowerment.mp4";

    if(plat || desk){
        introurl = "assets/video/mindmapintro.mp4";
        curiosityurl = "assets/video/mindmapcuriosity.mp4";  
        responsibilityurl = "assets/video/mindmapresponsibility.mp4";
        empowermenturl = "assets/video/mindmapempowerment.mp4";
    }else{
        introurl = "public/assets/video/mindmapintro.mp4";
        curiosityurl = "public/assets/video/mindmapcuriosity.mp4";  
        responsibilityurl = "public/assets/video/mindmapresponsibility.mp4";
        empowermenturl = "public/assets/video/mindmapempowerment.mp4";
    }

    function logOut(){
        console.log("logout");
        remove('cred');
        history.push('/home');
    }
    //slides
    const mySlides = useRef(null);
    const slideOpts = {
        initialSlide: 0,
        speed: 300
    };
    const scrollTop = () =>{
        // document?.querySelector("ion-content")?.scrollToTop(500);
         contentRef.current && contentRef.current.scrollToTop(500);
     }
     const contentRef = useRef<HTMLIonContentElement | null>(null);
    checkMindmap(//see if we need to show the load button
    ).then(function (finalResul){
        console.log(finalResul);
        setIsSaved(finalResul);
    }).catch(err => {
        console.log("e: " + err.message);
    });

    const init = async function(this: any) {
        setSwiper(await this.getSwiper());
        setCurrent(0);
    };
    const getIndex = async (event: any) => {
        let index: number = 0;
        await event.target.getActiveIndex().then((value: any) => (index=value));
        setCurrent(index);
    }
    const handleSlidesControlNext = () =>{ 
        document?.querySelector("ion-content")?.scrollToTop(500);
        swiper.slideNext(300); 
        contentRef.current && contentRef.current.scrollToTop(500);//for ios
    }
    const handleSlidesControlPrev = () =>{ 
        document?.querySelector("ion-content")?.scrollToTop(500);
        swiper.slidePrev(300); 
        contentRef.current && contentRef.current.scrollToTop(500);//for ios
    }

    //axios.get()//get the values from the mindset for the mindmap
    const checkForm = () => {
        //slide level
        console.log("validate form fields");
        //check the attitudes

        if(!mindmaptitle){
            setWinMessage("Explorer Mindset name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }
        if(!firstname){
            setWinMessage("First name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }
        /*if(!lastname){
            setWinMessage("Last name can't be blank");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }*/
        if(!mapquestion){
            setWinMessage("You need to include your statement for what you want to explore.");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }
        if(!issuccess){
            console.log("send form");
            publishMM(
                mapquestion,
                curiosity,
                responsibilityexplore,
                empowermentobstacles,
                empowermentovercome,
                observationdata,
                communicationcollection,
                collaboration,
                //planningorganizingsteps,
                problemsolvingcreativity,
                firstname,
                //lastname,
                mindmaptitle,
                schoolname,
            );
        }
    }
    function PosttoServer(bodyFormData:any){
        //var baseURL = 'https://expmindapp.wpengine.com/wp-json/'
        var baseURL = 'http://explorermindsetapp.com/wp-json/'
        //validate first 
        if(bodyFormData === ""){
            error = true;
        }else{
            error = false;
        }
        if(error){  
            setWinMessage('error');
        }else{//then send if it's good
            get("cred").then(function (finalResult) {
                const userD = JSON.parse(finalResult);
                const token = userD.authtoken;
                const email = userD.email;
                bodyFormData.set('post_title', email);
                bodyFormData.set('logged-email',email);

                console.log(bodyFormData);
                console.log(email);
                
                axios.post(baseURL + 'contact-form-7/v1/contact-forms/956/feedback', 
                    bodyFormData,
                {
                headers: { 
                    'Authentication':' Bearer ' + token 
                },
                timeout:8000,
                }).then(function (serverResponse) {
                    setShowLoading(false);
                    const postsD = serverResponse.data;
                    console.log(postsD);
                    console.log("error should popup");

                    //setLoad(true);//submission was a success
                    
                    if(serverResponse.data.message === 'Your Mind Map has been saved to your account. Click on "My Account" from the main menu to access and download under the "Save Mind Maps" section.'){
                        const message = "You can view it be logging into the website, it may take some time to appear in the app.";
                        setWinMessage(message);
                    }else{
                        setWinMessage(serverResponse.data.message);
                    }
                    //'Your Mind Map has been saved to your account. Click on \"My Account\" from the main menu to access and download under the \"Save Mind Maps\" section.'
                    if(serverResponse.data.status === 'mail_sent'){
                        const title = "Your Mind Map was saved to the server";
                        setWinMessageTitle(title);
                    }else{
                        const title = serverResponse.data.status
                        setWinMessageTitle(title);
                    }
                    
                    removeMindmap().then(function(){
                        resetForm();
                    });
                })
                .catch(function (error) {
                    setShowLoading(false);
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                    //temp
                    const message = "Congratulations your Mind map should be saved, it will be saved to the website and app, it may take some time to appear in the app.";

                    setWinMessage(message);
                    removeMindmap().then(function(){
                        resetForm();
                    });
                });
            }).catch(err => {//unable to load the local storage
                console.log("e: " + err.message);
            });
        }
    }
    function publishMM(
        mapquestion:any,
        curiosity:any,
        responsibility:any,
        empowerment1:any,
        empowerment2:any,
        observation:any,
        communication:any,
        collaboration:any,
        //planningorganizing:any,
        problemsolving:any,
        firstname:any,
        //lastname:any,
        mindmaptitle:any,
        schoolname:any
    ){
        setShowLoading(true);
        //send the data to the API
        let bodyFormData = new FormData();
        const stampTime:any = Date.now();
        bodyFormData.set('text-explore-statement',mapquestion);
        bodyFormData.set('textarea-curiosity',curiosity);
        bodyFormData.set('textarea-responsibility',responsibility);
        bodyFormData.set('textarea-empowerment',empowerment1);
        bodyFormData.set('textarea-empowerment2',empowerment2);
        bodyFormData.set('textarea-observation',observation);
        bodyFormData.set('textarea-communication',communication);
        bodyFormData.set('textarea-collaboration',collaboration);
        //bodyFormData.set('textarea-planning',planningorganizing);
        bodyFormData.set('textarea-problemsolving',problemsolving);
        bodyFormData.set('your-first-name', firstname);
        bodyFormData.set('your-last-name',"APP");
        bodyFormData.set('your-mindmap-name',mindmaptitle);
        bodyFormData.set('school-MM-name',schoolname);
        bodyFormData.set('timestamp',stampTime);
        
        PosttoServer(bodyFormData);
    }
    function resetForm(){
        console.log("form reset");
        document?.querySelector("ion-content")?.scrollToTop(500);swiper.slideTo(0);
        setMindmap('');
        setCuriosityquestion('');
        setResponsibilityExplore('');
        setEmpowermentObstacles('');
        setEmpowermentOvercome('');
        setObservationData('');
        setCommunicationCollection('');
        setCollaboration('');
        //setPlanningOrganizingSteps('');
        setProblemSolvingCreativity('');

        setFirstName('');
        //setLastName('');
        setMindMapTitle('My Mind Map');
        setSchoolName('');

        setIssuccess(true);
    }
    function handleSaveMindset(){
        console.log('save mindset');
        saveMindmap(
            mapquestion,
            curiosity,
            responsibilityexplore,
            empowermentobstacles,
            empowermentovercome,
            observationdata,
            communicationcollection,
            collaboration,
            //planningorganizingsteps,
            problemsolvingcreativity,
            firstname,
            //lastname,
            mindmaptitle,
            schoolname
        );
    }
    function handleLoadMindset(){
        console.log('load mindset');
        loadMindmap().then(function (finalResul){
            console.log(finalResul);
            const userD = JSON.parse(finalResul);
            setMindmap(userD.mapquestion);
            setCuriosityquestion(userD.curiosity);
            setResponsibilityExplore(userD.responsibility);
            setEmpowermentObstacles(userD.empowerment);
            setEmpowermentOvercome(userD.empowerment2);
            setObservationData(userD.observation);
            setCommunicationCollection(userD.communication);
            setCollaboration(userD.collaboration);
            //setPlanningOrganizingSteps(userD.planningorganizing);
            setProblemSolvingCreativity(userD.problemsolvingcreativity);
            setFirstName(userD.firstname);
            //setLastName(userD.lastname);
            setMindMapTitle(userD.mindmaptitle);
            setSchoolName(userD.school);
        }).catch(err => {
            //console.log("e: " + err.message);
        }); 
    }
    //video 
    const platform = Capacitor.getPlatform();
    //const history = useHistory();
    var api: any = useRef<boolean>(false);
    let url: string = "";
    const [type,setType] = useState("");
   
    useEffect( () => {
      async function launchFullscreen(): Promise<void>  {
        //set type and set api etc
        //await set('url', url);
        await set('api', api.current ? "true" : "false");
        history.push('/createmindmap');//push this section first so the go back works ok. 
        history.push('/fullscreen');
      }
        if(type.length >  0) launchFullscreen();
    },[ api, platform, history, type]);
  
    function launchPlayer(senturl:string){
        url = senturl;
        //console.log(senturl + "" + url);
        set('url', url).then(()=>{
          console.log(senturl);
          let someNum = Math.random();
          setType(someNum.toString());
          console.log(type);
        });
        
    }
    return(
        <>
        <IonPage id="visual">
        <LoginCheck/>/
        <IonHeader translucent={true} >
            <IonToolbar>
                <IonButton size="small" slot="start" color="primary" onClick={() => history.replace('/plan')} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
                <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  className="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
            </IonToolbar>
        </IonHeader>
        <IonContent ref={contentRef} scrollEvents={true}>
        <IonLoading
                            cssClass='my-custom-class'
                            isOpen={showLoading}
                            onDidDismiss={() => setShowLoading(false)}
                            message={'Please wait...'}
                            spinner={'bubbles'}
                            duration={9000}
                        />
                             <IonAlert
                                isOpen={issuccess}
                                onDidDismiss={() => setIssuccess(false)}
                                cssClass="my-success-class"
                                header={winmessagetitle}
                                message={winmessage}
                                buttons={["Close"]}
                            />
            <IonSlides
                options={slideOpts} 
                mode="ios"  
                onIonSlidesDidLoad={init}  
                ref={mySlides}
                onIonSlideDidChange={(event: any)=> getIndex(event)}
                >
                <IonSlide class="ionslide">
                    <IonCard class="ioncard">
                        <IonText class="innertext learntext">
                            <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h5>your</h5>
                            <h2>Mind Map</h2>
                            <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(introurl)}>Launch Video</IonButton>
                        </IonText>
                        <p>What is the question, topic, idea, task, or issue I want to Explore
    I want to Explore</p>
                        <IonTextarea
                        name="mapquest-definition" 
                        class="textarea" 
                        value={mapquestion}
                        maxlength={170}
                        onIonChange={(e) => setMindmap(e.detail.value!)}
                        >
                        </IonTextarea>
                    </IonCard>
                </IonSlide>

                <IonSlide>
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                            <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Curiosity</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(curiosityurl)}>Launch Video</IonButton>
                        <strong>What I want to Explore:</strong>
                        <p>Think of questions that will help you explore...How? Why? What? Are there different angles, scales or perspectives I can ask questions about? What questions do I need to ask to explore this?</p><p>(max 170 characters)</p>
                        <IonTextarea    
                        name="curiosity-question" 
                        class="textarea" 
                        value={curiosity}
                        onIonChange={(e) => setCuriosityquestion(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>
                </IonSlide>

                <IonSlide>
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                            <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Responsibility</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <IonButton fill="outline"  style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(responsibilityurl)}>Launch Video</IonButton>

                        <strong>What I want to Explore:</strong>
                        <p>How can exploring this help you build responsibility and respect for yourself and others? What different perspectives might you learn?</p><p>(max 140 characters)</p>
                        <IonTextarea    
                        name="responsibility-definition" 
                        class="textarea" 
                        value={responsibilityexplore}
                        maxlength={140}
                        onIonChange={(e) => setResponsibilityExplore(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>      
                </IonSlide>
                <IonSlide>
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                            <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Empowerment</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <IonButton fill="outline" style={{color:'#7a5b3f'}} onClick={(e)=>launchPlayer(empowermenturl)}>Launch Video</IonButton>

                        <strong>What I want to Explore:</strong>
                        <p>What are some ways I can take action, try something new or make a positive impactwhile exploring this?</p><p>(max 100 characters)</p>
                        <IonTextarea    
                        name="empowerment-obstacles" 
                        class="textarea" 
                        value={empowermentobstacles}
                        onIonChange={(e) => setEmpowermentObstacles(e.detail.value!)}
                        ></IonTextarea>
                        <p>What obstacles might I have and how will I overcome them?</p><p>(max 100 characters)</p>
                        <IonTextarea        
                        name="empowerment-overcome" 
                        class="textarea" 
                        value={empowermentovercome}
                        maxlength={100}
                        onIonChange={(e) => setEmpowermentOvercome(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>
                </IonSlide>
                <IonSlide>
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                           <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Observation</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <strong>What data/information can I collect?</strong>
                        -Or- <strong>What do I need to notice or observe?</strong>
                         <p>(Remember observations can be made through all of our senses: smell, sight, hearing, touch, taste)</p><p>(max 140 characters)</p>
                        <IonTextarea        
                        name="empowerment-overcome" 
                        class="textarea" 
                        value={observationdata}
                        maxlength={140}
                        onIonChange={(e) => setObservationData(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>
                </IonSlide>
                <IonSlide>
                     <IonCard class="ioncard">
                        <IonText class="padded learntext">
                           <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Communication</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <strong>How can I collect and share information?</strong>
                        <p>(Drawing, writing, discussing, storytelling, reading and research, etc)</p><p>(max 140 characters)</p>
                        <IonTextarea        
                        name="empowerment-overcome" 
                        class="textarea" 
                        value={communicationcollection}
                        maxlength={140}
                        onIonChange={(e) => setCommunicationCollection(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>
                </IonSlide>
                <IonSlide>
                    <IonCard class="ioncard">
                        <IonText class="padded learntext">
                           <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Collaboration</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <strong>Who can I work with to help me with this project?</strong>
                        <p>(max 140 characters)</p>
                        <IonTextarea        
                        name="collaboration" 
                        class="textarea" 
                        value={collaboration}
                        maxlength={140}
                        onIonChange={(e) => setCollaboration(e.detail.value!)}
                        ></IonTextarea>
                    </IonCard>
                </IonSlide>

                <IonSlide>
                        <IonCard class="ioncard">
                        <IonText class="padded learntext">
                           <span>[</span>  <h3>Plan</h3> <span>]</span>
                            <h4>Problem Solving and Creativity</h4>
                            <div></div>
                            <strong></strong>
                        </IonText>
                        <strong>How can thinking creatively help me explore this?</strong>
                        <p>How can I approach it with more than one idea or option? What tools do I need to explore this?</p>
                        <p>(max 140 characters)</p>
                        <IonTextarea        
                        name="problemsolvingcreativity" 
                        class="textarea" 
                        value={problemsolvingcreativity}
                        maxlength={140}
                        onIonChange={(e) => setProblemSolvingCreativity(e.detail.value!)}
                        ></IonTextarea>
                        </IonCard>
                </IonSlide>

                <IonSlide>
                        <IonCard class="ioncard">
                        <h2>More Info</h2>
                        Mind Map Name
                        <IonItem>
                            <IonLabel position="stacked">Mind Map Title</IonLabel>
                            <IonInput 
                            value={mindmaptitle}
                            placeholder="Title"
                            onIonChange={e => setMindMapTitle(e.detail.value!)}
                            ></IonInput>
                        </IonItem>
                        <IonItem>
                        <IonLabel position="stacked">First Name</IonLabel>
                        <IonInput 
                        value={firstname}
                        placeholder="First Name"
                        onIonChange={e => setFirstName(e.detail.value!)}
                        ></IonInput>
                        </IonItem>
                        <IonItem>
                        <IonLabel position="stacked">School</IonLabel>
                        <IonInput 
                        value={schoolname}
                        placeholder="School Name"
                        onIonChange={e => setSchoolName(e.detail.value!)}
                        ></IonInput>
                        </IonItem>
                        <IonButton onClick={()=>checkForm()}>Finish Mind map</IonButton>
                        </IonCard>
                </IonSlide>
               
        
                
              

           </IonSlides>
           <IonFabButton size="small" onClick={()=>scrollTop()}>top</IonFabButton>
       </IonContent>
       <IonToolbar class="slidenav">
        {(function() { //check to see what page we are one
            let buttonDisabled = false;
            if(currentcheck > 0){ buttonDisabled = false;}else{buttonDisabled = true;}
            return(
                <IonButton onClick={() => handleSlidesControlPrev() } color="primary" fill="solid" class="prev" disabled={buttonDisabled}><IonIcon icon={arrowBackOutline} class="icon" slot="icon-only"/></IonButton>
            )
        })()} 
        {(function() { //check to see if the toggle is applied
            if(isSaved !== 'none'){//optional rows.
                return (
                    <>
                    <IonButton onClick={()=>handleLoadMindset()} 
                    color="primary" 
                    fill="solid" 
                    class="load">Load Saved</IonButton> 
                    </>
                )
            }
        })()}  
        <IonButton onClick={()=>handleSaveMindset()} 
                    color="primary" 
                    fill="solid" 
                    class="save">Save</IonButton>
        {(function() { //check to see what page we are one
        let buttonDisabled = false;
            if(currentcheck <= 8){ buttonDisabled = false;}else{buttonDisabled = true;}
                return(
                    <IonButton onClick={() => handleSlidesControlNext() } color="primary" fill="solid" class="next" disabled={buttonDisabled}><IonIcon icon={arrowForwardOutline} class="icon" slot="icon-only"/></IonButton>   
                )
            
        })()} 
        </IonToolbar>
        <FooterCom/>
        </IonPage>
        </>
    )
}
export default CreateMindmap;